"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modalSelectors = void 0;
const getModalIsOpen = (state, modalKey) => { var _a; return !!((_a = state[modalKey]) === null || _a === void 0 ? void 0 : _a.isOpen); };
exports.modalSelectors = {
    getModalIsOpen
};
